export const types = {
    TRIGGER: 'TRIGGER',
};
